import { GraphObject, Node, Panel, Spot } from 'gojs';
import { isLayoutPositionedBinding, locationBinding, zOrderBindings } from '../shared/utils/shared-bindings';
import { contentPanel } from './parts/content-panel';
import { nodeShape } from './parts/node-shape';
import { nodeBackgroundBinding, nodeStrokeBinding } from './utils/bindings';
import { nodeMouseHover, nodeMouseLeave } from './utils/events';

const $ = GraphObject.make;

export const defaultNodeTemplate = () =>
  $(
    Node,
    Node.Spot,
    {
      selectionAdorned: false,
      deletable: false,
      selectable: false,
      mouseHover: nodeMouseHover,
      mouseLeave: nodeMouseLeave,
    },

    // Bindings
    locationBinding(),
    isLayoutPositionedBinding(),
    ...zOrderBindings(),

    // Parts
    mainNodePanel(nodeShape([nodeStrokeBinding(), nodeBackgroundBinding()]), contentPanel()),
  );

const mainNodePanel = (...children: GraphObject[]) =>
  $(
    Panel,
    Panel.Auto,
    {
      defaultAlignment: Spot.Left,
      cursor: 'pointer',
    },
    ...children,
  );
